import { Room, RoomOptions, RoomConnectOptions, ConnectionState } from 'livekit-client';
import React, { useEffect } from 'react';
import { useRoom } from 'core';
import { clearAllSnapshots } from 'hooks/useVideoSnapshot';
import { ControlsProps } from './components';
import { StageView } from './StageView';

export interface RoomProps {
    url: string;
    token: string;
    hasRecorder?: boolean;
    roomOptions?: RoomOptions;
    connectOptions?: RoomConnectOptions;
    // when first connected to room
    onConnected?: (room: Room) => void;
    // when user leaves the room
    onLeave?: (room: Room) => void;
    controlRenderer?: (props: ControlsProps) => React.ReactElement | null;
}

export const LiveKitRoom: React.FC<RoomProps> = ({
    url,
    token,
    roomOptions,
    connectOptions,
    controlRenderer,
    onConnected,
    onLeave,
    hasRecorder,
}) => {
    const roomState = useRoom(roomOptions, hasRecorder);

    useEffect(() => {
        roomState.connect(url, token, connectOptions).then((room) => {
            if (!room) return;

            if (onConnected && room.state === ConnectionState.Connected) {
                onConnected(room);
            }
            if (hasRecorder && room.state === ConnectionState.Connected) {
                console.log('START_RECORDING');
            }
        });

        // Очищаем snapshots при выходе из комнаты
        return () => {
            clearAllSnapshots();
        };
    }, []);

    return (
        <StageView
            roomState={roomState}
            controlRenderer={controlRenderer}
            onLeave={onLeave}
            hasRecorder={hasRecorder}
        />
    );
};
